import {debounce} from "./debounce";

/**
 * Parallax
 * @type {string}
 */
const parallax = (parallaxItems) => {
    if (!parallaxItems) return;
    const handleParallaxScroll = () => {
        parallaxItems?.forEach((item) => {
            const parallaxValue = item.dataset.parallax ?? 14
            const direction = item.dataset.direction === 'down' ? -1 : 1
            let dataParallax = item.getBoundingClientRect().top / parallaxValue * direction + 'px';
            let child = Array.from(item.children).find(el => el.tagName.toLowerCase() === 'img' || el.tagName.toLowerCase() === 'picture' || el.tagName.toLowerCase() === 'video' || el.classList.contains('swiper-wrapper'));
            if (child.tagName.toLowerCase() === 'picture') child = child.querySelector('img');
            child.style.transform = 'translate3d(0, ' + dataParallax + ', 0)';
        });
    }
    handleParallaxScroll();
    const onScroll = debounce(() => handleParallaxScroll(), 6);
    window.addEventListener("scroll", onScroll);
}

export default parallax;